import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import { queryKeys } from '@/api/query-keys'

const MONGO_OBJECT_ID_HEX24 = /^[a-fA-F0-9]{24}$/

function isValidMongoObjectIdString(id: string): boolean {
  return MONGO_OBJECT_ID_HEX24.test(id.trim())
}

export function useMarkRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (notificationId: string) => {
      const id = (notificationId ?? '').trim()
      if (!isValidMongoObjectIdString(id)) return
      await apiClient.patch(`/api/v1/notifications/${id}/read`)
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.notifications.all() })
    },
  })
}

export function useMarkAllRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      await apiClient.patch('/api/v1/notifications/read-all')
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.notifications.all() })
    },
  })
}
